const customInitialState = {
  guestMode: {
    data: {
      isGuestMode: true
    }
  }
}

export default customInitialState
